import * as i0 from "@angular/core";
export class IndexOfPipeModule {
}
IndexOfPipeModule.ɵfac = function IndexOfPipeModule_Factory(t) { return new (t || IndexOfPipeModule)(); };
IndexOfPipeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IndexOfPipeModule });
IndexOfPipeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
